<template>
  <div>
    <div v-if="actionType">
      <div class="p-2">
        <div class="bg-white border-radius--light py-2">
          <div class="col-12 mb-2 pl-4 pt-3">
              <em class="text-orange mr-1"
                  :class="[actionTypeIcon, actionTypeColor]" />
              <span class="ml-2">{{actionTypeTitle}}</span>
            </div>

          <ValidationObserver ref="formValidator">
            <div class="px-4">
              <div class="row">
                <div v-if="!isActionPlan" class="col-md-12 mb-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Razón"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="info.selectedReason"
                      label="Razón:"
                      :options="rejectionReasonsFiltered"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :error="errors[0]"
                      custom-error-msg="Favor de seleccionar la razón."
                      @input="onChangeReasonsHandler"
                    />
                  </ValidationProvider>
                </div>
                 <div v-if="mustUploadDocument" class="col-md-12 mt-3">
                  <validation-provider                 
                    v-slot="{ errors }"
                    rules="required"
                  >
                   <label class="input-label">
                      Documento de Rechazo de Servicios:
                    </label>
                  <custom-file-input
                    ref="fileUpload"
                    v-model="info.document"
                    display-style="normal"                    
                    :accept="'.pdf'"                   
                    label-position="left"
                    :error="errors[0]"
                    custom-error-msg="El documento de rechazo de servicios es requerido."
                  />
                  </validation-provider>
                  
                </div>
                <div class="col-md-12 mt-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="commentLabel"
                    rules="required"
                  >
                    <custom-text-area
                      v-model="info.comment"
                      :label="commentLabel + ':'"
                      :maxlength="500"
                      :rows="2"
                      :error="errors[0]"
                      :single-line="true"
                      :max-length="500"
                      custom-error-msg="Favor de entrar el comentario."
                    />
                  </ValidationProvider>
                </div>               
              </div>
              <div class="row">
                <div class="col-12 justify-content-end d-flex my-3">
                  <action-button
                    variant="outline-danger mr-2"
                    i="fas fa-times-circle"
                    min-width="124px"
                    @click="dispose"
                  >
                    Cancelar
                  </action-button>
                  <action-button
                    variant="success"
                    min-width="124px"
                    @click="handleSubmit"
                  >
                    Guardar
                  </action-button>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CustomDropDown,
  ActionButton,
  CustomTextArea
} from "@/components/common";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import referralService from "@/services/pei/thrpyReferrals";
import referralActionTypes from "@/utils/constants/student/referralActionTypes";
import commentTypes from "@/utils/constants/comment/codeAdmissionCommentTypes";
import { modulesName } from "@/modules";
import * as referralTypes from "@/modules/referral/store/types.js";
import { createNamespacedHelpers } from "vuex";
import alertMixin from "@/mixin/alert.mixin.js";
import referralRejectionReason from "@/utils/constants/pei/referral/referralRejectionReason"
import objectToFormData from "object-to-formdata";
import CustomFileInput from "CustomFileInput";
import admissionStatus from "@/utils/constants/pei/referral/admissionStatus"
import {
  approveProvisionalRemedyRequest  
} from "@/modules/referral/api.js";  

const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} = createNamespacedHelpers(modulesName.referralModuleName);

export default {
  name: "ServiceAction",
  components: {
    CustomDropDown,
    CustomFileInput,
    ActionButton,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [alertMixin],
  data() {
    return {
      collapse: false,
      info: {
        selectedReason: null,
        comment: "",
        document: null
      },
      catalog: {
        reasonList: [{ id: 1, name: "Aprobada por CSEE" }]
      }
    };
  },
  computed: {
    ...mapState({
      referralFilters: state => state.referral.filters.lastFiltered
    }),
    ...mapGetters({
      rejectionReasons: "getReferralRejectionReasons"
    }),
    rejectionReasonsFiltered(){
      if(this.statusId == admissionStatus.NoVinculado)
      {
        let excludeReasons = [
          referralRejectionReason.ReferidoVinculadoLugarServicioIncorrecto, 
          referralRejectionReason.EspecialistaNoTieneEspacioDisponible
        ]

        return this.rejectionReasons.filter(c=> !excludeReasons.includes(c.id))
      }
      if(this.statusId == admissionStatus.Vinculado)
      {
        let excludeReasons = [
          referralRejectionReason.RechazoServiciosPartePadreMadreEncargado,           
        ]

        return this.rejectionReasons.filter(c=> !excludeReasons.includes(c.id))
      }
      return this.rejectionReasons;
    },
    actionTypeIcon() {
      switch (this.actionType) {
        case referralActionTypes.denegate:
        case referralActionTypes.denegateLinked:
          return "fas fa-window-close";
        case referralActionTypes.actionPlan:
        case referralActionTypes.breachReason:
          return "fas fa-plus-square";
        default:
          return "";
      }
    },
    actionTypeTitle() {
      switch (this.actionType) {
        case referralActionTypes.denegate:
          return "Denegar Referido";
        case referralActionTypes.denegateLinked:
          return "Denegar Vínculo";
        case referralActionTypes.actionPlan:
          return "Plan Acción";
        case referralActionTypes.breachReason:
          return "Documentación Incumplimiento";
        default:
          return "";
      }
    },
    actionTypeColor() {
      if (
        [
          referralActionTypes.denegate,
          referralActionTypes.denegateLinked
        ].includes(this.actionType)
      ) {
        return "orange-icon";
      } else {
        return "green-icon";
      }
    },
    isDenegateLinked() {
      return this.actionType == referralActionTypes.denegateLinked;
    },
    actionTypes() {
      return referralActionTypes;
    },
    isActionPlan() {
      return this.actionType === this.actionTypes.actionPlan;
    },
    commentLabel() {
      return this.isActionPlan
        ? "Descripción del Plan de Acción"
        : "Comentario";
    },
    mustUploadDocument(){
      let reasonsMustUploadDocument = [referralRejectionReason.RechazoServiciosPartePadreMadreEncargado];

      return reasonsMustUploadDocument.includes(this.info.selectedReason?.id);
    }
  },
  methods: {
    ...mapMutations([referralTypes.SET_REFERRAL_ACTION_TYPE]),
    ...mapActions([
      referralTypes.ACTION_TYPES.DENEGATE_REFERRAL,
      referralTypes.ACTION_TYPES.GET_REFERRALS
    ]),
    collapseItem() {
      this.collapse = !this.collapse;
      this.$emit("on-collapse", this.collapse);
    },

    async saveComment(payload) {
      await referralService.addCommentReferral(payload);
      this.ShowToast("Notificación", this.getMessage("190714"), "success");
      this.reload();
      this.dispose();
    },
    async handleSubmit() {
      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) {
        this.ShowToast("Error", "Favor de completar la información solicitada.", "error");
      } else {
        const payload = {
          admissionId: this.admissionId,
          comment: this.info.comment,
          rejectionReasonId: this.info.selectedReason
            ? this.info.selectedReason.id
            : null
        };
        if (this.isDenegateLinked) {
          this.$emit("setLinkedToNoLinked", payload);
        } else if (
          this.actionType === referralActionTypes.actionPlan ||
          this.actionType === referralActionTypes.breachReason
        ) {
          let commentTypeId = 0;
          switch (this.actionType) {
            case referralActionTypes.actionPlan:
              commentTypeId = commentTypes.PlanAccion;
              break;
            case referralActionTypes.breachReason:
              commentTypeId = commentTypes.RazonIncumplimiento;
              break;
            default:
              break;
          }
          payload.commentType = commentTypeId;
          this.saveComment(payload);
        } else {
          this.save();
        }
      }
    },
    reload() {
      this[referralTypes.ACTION_TYPES.GET_REFERRALS]({
        filters: this.referralFilters
      });
    },
    async save() {
      const payload = {
        admissionId: this.admissionId,
        rejectionReasonId: this.info.selectedReason.id,
        comment: this.info.comment
      };      

      let formData = objectToFormData(payload, { indices: true });

       if (this.mustUploadDocument) {
         formData.append(
           "document",
           this.info.document
         );
       }

      const { data: isSaveSuccess } = await this[
        referralTypes.ACTION_TYPES.DENEGATE_REFERRAL
      ]( formData );
      if (isSaveSuccess) {
        this.ShowToast("Notificación", this.getMessage("190714"), "success");
        this.reload();
        this.cancel();
      }
    },
    async onChangeReasonsHandler() {
      let self = this;
      
      if(this.info.selectedReason?.id == referralRejectionReason.RecibeServiciosRP)
      {
        self
        .$ApiGet(
          `/api/studentreferrals/checkprovisionalremedyrequest/${this.studentSieId}/${this.disciplineTypeId}`
        )
        .then(async res => {
          if (res.data != null && res.data != "") {
            self.savedRequestId = res.data.id;
            self.savedStudentReferralId = res.data.StudentReferralId;

            this.ShowCancelModal(
              "Confirmación",
              `Se encontró un servicio activo en Remedio Provisional para la misma disciplina del referido bajo la(s) solicitud(es) ${res.data.requestNumber}. ¿Desea identificar este referido como Aprobado en Remedio Provisional utilizando la solicitud encontrada?`,
              "Sí",
              "No"
            ).then(async response => {
              if (response) {
                await approveProvisionalRemedyRequest({
                  admissionId: this.admissionId,
                  requestId: self.savedRequestId,
                  disciplineTypeId: this.disciplineTypeId
                });
                this.ShowToast("", "El referido ha sido Aprobado en Remedio Provisional exitosamente", "success");
                this.reload();
              }
            });  
          } 
          else{
            this.info.selectedReason = null;
            this.ShowToast('Advertencia', 'No se encontró un servicio activo en Remedio Provisional para la disciplina del referido, por lo cual no es posible la denegación por esta razón.', 'error');
          }      
        })
        .catch(err => {
          this.showError(err);
        });
      }            
    },
  },
  watch: {
    actionType(newVal, oldVal) {
      if (newVal != oldVal) {
        this.info = {
          selectedReason: null,
          comments: ""
        };
      }
    }
  },
  props: {
    actionType: {
      type: Number,
      default: () => null
    },
    admissionId: {
      type: Number,
      default: () => -1
    },
    disciplineTypeId: {
      type: Number,
      default: () => -1
    },
    studentSieId: {
      type: Number,
      default: () => -1
    },
    statusId: {
      type: Number,
      default: () => -1
    },
    dispose: {
      type: Function,
      default: () => undefined
    }
  }
};
</script>

<style scoped lang="scss">
$collapseOpenColor: #bcbec0;
$collapseCloseColor: #ff7058;
$colorWhite: #fff;
$panelBorderColor: #f2f2f2;

.separator-additional-info {
  display: flex;
  align-items: center;
  text-align: center;
  color: $colorWhite;
  height: 5px;
  justify-content: center;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  &.up {
    background: $collapseCloseColor;
  }
  &.down {
    background: $collapseOpenColor;
  }
  font: 700 14px/17px Lato;
  .title-container {
    border-radius: 21px;
    padding: 5px 16px 8px 16px;
    color: $colorWhite;
    &.up {
      background: $collapseCloseColor;
    }
    &.down {
      background: $collapseOpenColor;
    }
    em {
      margin-right: 10px;
      font-weight: bold;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.info-panel {
  padding: 15px 10px 1px 20px;
  border: 5px solid $panelBorderColor;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
  .info-panel-main-title {
    em {
      color: $collapseCloseColor;
    }
    span {
      text-align: left;
      font: Bold 16px/19px Lato;
      letter-spacing: 0px;
      color: #3f5b60;
      opacity: 1;
      margin-left: 7px;
    }
  }
}
.csee-custom-width {
  max-width: 12rem;
}

.tag-badge {
  display: flex;
  align-items: center;
  padding-right: 1em;
  height: 31px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  margin-bottom: 10px;
}

.dot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
  font-size: 1.1rem;
  padding-right: 4px;
  line-height: 7px;
  margin-left: 1px;
}

.green-icon {
  color: #2cb782;
  font-size: 1.1rem;
  padding-right: 4px;
  line-height: 7px;
  margin-left: 1px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.form-field {
  strong {
    display: block;
    margin-bottom: 15px;
  }
}
</style>
